import { PlayGameMeta } from "../core";

export interface PlayLevelInfo {
  level: number;
  label: string;
  requiredGamesCompleted: number;
}

export const PLAY_LEVELS: PlayLevelInfo[] = [
  { level: 1, label: "Novice", requiredGamesCompleted: 0 },
  { level: 2, label: "Curieux", requiredGamesCompleted: 3 },
  { level: 3, label: "Explorateur", requiredGamesCompleted: 8 },
];

export function computeLevelFromCompletedGames(count: number): PlayLevelInfo {
  if (count === undefined || count === null || Number.isNaN(count)) {
    return PLAY_LEVELS[0];
  }
  const sorted = [...PLAY_LEVELS].sort((a, b) => a.requiredGamesCompleted - b.requiredGamesCompleted);
  let current = sorted[0];
  for (const lvl of sorted) {
    if (count >= lvl.requiredGamesCompleted) {
      current = lvl;
    }
  }
  return current;
}
